import { gql } from "@apollo/client"

export const GET_TERMINAL_BY_ID = gql`
  query getTerminalById($id: Int!, $resolution: String!, $fromTimeStamp: DateTime!, $toTimeStamp: DateTime!) {
    apiTerminal(id: $id) {
      id
      name
      apiId
      initialStartDate
      totalUsageMetrics(resolution: $resolution, fromTimeStamp: $fromTimeStamp, toTimeStamp: $toTimeStamp) {
        timeStamp
        mbCount
      }
    }
  }
`
